export const EmployeeRoles = [
  { label: 'Manager', value: 'M' },
  { label: 'Employee', value: 'E' },
];

export const EmployeeSalaryUnit = [
  { label: 'Month', value: 'M' },
  { label: 'Hour', value: 'H' },
];

/**
 * An employee's display name. Employees are HR records now and carry their own names; `user` is
 * only set once someone has a login, so reading `employee.user.firstName` printed
 * "undefined undefined" for everyone without one. Falls back to the user's name, then to ''.
 */
export const employeeName = (
  employee?: { firstName?: string; lastName?: string; user?: { firstName?: string; lastName?: string } | null } | null
): string =>
  `${employee?.firstName ?? employee?.user?.firstName ?? ''} ${
    employee?.lastName ?? employee?.user?.lastName ?? ''
  }`.trim();
